import z from "zod";
import { DefaultSchema } from "../default-schema";
import { v7 } from "uuid";
import { TipoInventarioArquivo } from "./tipo-inventario-arquivo";
import { StatusInventarioArquivo } from "./status-inventario-arquivo";


export const InventarioArquivoSchema = DefaultSchema.extend({
    arquivo_id: z.string().default(() => {
        return v7()
    }),
    inventario_id: z.string().default(() => {
        return v7()
    }),
    status: z.enum(StatusInventarioArquivo).default(StatusInventarioArquivo.PENDENTE),
    tipo: z.enum(TipoInventarioArquivo).default(TipoInventarioArquivo.CADASTRO_PRODUTOS),
    processed: z.int().default(0),
    total: z.int().default(0)
})

